module.exports = __webpack_public_path__ + "static/media/white.b3e4b500.svg";